import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BookOpen, Plus, Trash2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Loader, EmptyState, Badge, DemoTag } from "@/components/kit";

export default function Menus() {
  const nav = useNavigate();
  const [menus, setMenus] = useState(null);
  const load = () => api.get("/menus").then(({ data }) => setMenus(data.menus || [])).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);
  const del = async (id, e) => { e.preventDefault(); e.stopPropagation(); await api.delete(`/menus/${id}`); toast.success("Menu deleted."); load(); };

  if (!menus) return <Loader />;
  return (
    <div>
      <PageHeader eyebrow="Library" title="Menus" subtitle="Every menu project you've composed."
        action={<button onClick={() => nav("/create")} data-testid="new-menu-btn" className="btn-gold px-6 py-3 text-xs uppercase tracking-widest rounded-sm flex items-center gap-2"><Plus size={15} /> New Menu</button>} />
      {menus.length === 0 ? (
        <EmptyState icon={BookOpen} title="No menus yet" body="Start from a vibe, your kitchen or a theme."
          action={<Link to="/create" className="btn-gold px-6 py-3 text-xs uppercase tracking-widest rounded-sm">Start Plating</Link>} />
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4 stagger">
          {menus.map((m) => (
            <Link key={m.id} to={`/menus/${m.id}`} data-testid={`menu-card-${m.id}`} className="matte-card p-6 group">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <Badge tone={m.status === "approved" ? "green" : "muted"}>{m.status}</Badge>
                  {m.demo && <DemoTag />}
                </div>
                <button onClick={(e) => del(m.id, e)} className="text-white/30 hover:text-red-400 p-1"><Trash2 size={15} /></button>
              </div>
              <h3 className="font-serif text-2xl group-hover:gold-text transition-colors">{m.menu_name}</h3>
              <p className="text-white/45 text-sm mt-2 line-clamp-2">{m.concept}</p>
              <div className="flex items-center justify-between mt-5 pt-4 border-t border-white/5">
                <span className="text-white/50 text-sm">{m.course_count} courses · {m.guests} guests</span>
                <span className="font-mono text-gold">${m.revenue_potential?.toLocaleString?.()}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
